import { Environment } from '@fitscovery/common/environments';

export const environment: Environment = {
  production: false,
  fitscoveryApps: {
    accountUrl: '',
    adminUrl: '',
    fitscoveryUrl: '',
    myDiscoveryUrl: '',
    backofficeUrl: '',
    onboardingUrl: ''
  },
  apiKeys: {
    appInsights: '',
    googleMaps: '',
    recaptchaKey: ''
  },
  azureFunctionsApi: {
    auth: '',
    events: '',
    memberships: '',
    partners: '',
    payments: '',
    posts: '',
    products: '',
    users: '',
    workouts: '',
    bookings: ''
  },
  azureFunctions: {
    images: {
      uploadUrl: '',
      api: '',
      functionsKey: ''
    }
  },
  cloudFunctionApi: '',
  paymentsApi: {
    paymongo: '',
    paymongoKey: ''
  },
  xendItApi: {
    url: '',
    key: ''
  },
  firebase: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },
  facebook: {
    appId: '',
    clientToken: ''
  },
  version: '0.0.0',
  nodeApi: {
    users: ''
  }
};
